import { useQuery } from '@tanstack/react-query'
import { SPEND_COUNTRY_GROUPS } from 'api/react-query/keys'
import { getCountryGroups } from 'SpendControl/endpoints'

export const useGetCountryGroups = () =>
  useQuery({
    queryKey: [SPEND_COUNTRY_GROUPS],
    queryFn: getCountryGroups,
  })
